import { createFileRoute } from "@tanstack/react-router";

import { Audit } from "./-audit";
import { parseAuditFilters } from "../../../workspaces/label/pages/audit-search";

export const Route = createFileRoute("/_console/label/audit/")({
  validateSearch: parseAuditFilters,
  component: AuditIndex,
});

/** The audit with no episode open: a seat, and the work it submitted. */
function AuditIndex() {
  return <Audit state={Route.useSearch()} />;
}
